module.exports = __webpack_public_path__ + "media/audio4.ace5e5af.wav";